import React, { useEffect, useState } from 'react';
import { NodeResizer } from 'reactflow';
import { MindMapContext } from '../../Context/contex';
import useMindMapService from '../../hooks/useMindMapService';
import { emitNodeUpdate } from '../../Socket/socket';
import { useParams } from 'react-router-dom';

const Resizer = ({ isSelected, setHeight, setWidth, inputStyle, setisResize, isResize }) => {
  const { documentId } = useParams();
  const { isReadOnly, selectedNodeId, nodes, edges, setNodes, setIsDocumentChanged } = MindMapContext();
  const mindMapService = useMindMapService();
  const [nodePosition, setNodePosition] = useState({});

  const handleResize = (e, newSize) => {
    if (isResize === false) {
      setisResize(true);
    }
    setWidth(newSize.width);
    setHeight(newSize.height);

  };
  const handleResizeEnd = (e, node) => {
    // Pre-compute updated nodes so the template snapshot reflects the new size.
    const updatedNodes = nodes.map((n) => {
      if (n.id === selectedNodeId) {
        return { ...n, data: { ...n.data, width: node.width, height: node.height } };
      }
      return n;
    });
    setNodes(updatedNodes);
    // Preserve existing behaviour: keep nodePosition state in sync.
    const resizedNode = updatedNodes.find((n) => n.id === selectedNodeId);
    if (resizedNode) setNodePosition(resizedNode.position);

    mindMapService.updateNode(
      selectedNodeId,
      { style: { width: node.width, height: node.height } },
      { nodes: updatedNodes, edges }
    );
    let payload = {
      id: selectedNodeId,
      nodePosition: node,
      style: { width: node.width, height: node.height },
      documentId: documentId,
    };
    emitNodeUpdate(payload);
    setIsDocumentChanged(true);
  };
  useEffect(() => {
    const errorHandler = (e) => {
      if (
        e.message.includes(
          "ResizeObserver loop completed with undelivered notifications" ||
          "ResizeObserver loop limit exceeded"
        )
      ) {
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.style.display = "none";
        }
      }
    };
    window.addEventListener("error", errorHandler);

    return () => {
      window.removeEventListener("error", errorHandler);
    };
  }, []);
  return (
    <>
      <div key={selectedNodeId}>
        <NodeResizer
          color="#ff0071"
          isVisible={isReadOnly ? false : isSelected}
          onResize={handleResize}
          onResizeEnd={handleResizeEnd}
          style={inputStyle}
        />
      </div>
    </>
  )
}

export default Resizer;